    // header search bar close function
    const search_parentElement = document.getElementById("header-group");
    const headerHeight = search_parentElement ? search_parentElement.offsetHeight : 0;
    const searchClose = search_parentElement.querySelector("#searchQuery .closeButton");
    const suggestion_overlay = search_parentElement.querySelector(".suggestion__overlay");

    if (suggestion_overlay) {
      suggestion_overlay.style.setProperty("top", `${headerHeight}px`, "important");
    }

    if (searchClose) {
      searchClose.addEventListener("click", () => {
        console.log("Search close button clicked!!")
        if (search_parentElement.classList.contains("search-opened")) {
          search_parentElement.classList.remove("search-opened");
        }
      });
    }
    // header search bar close function
    
    
    document.querySelectorAll('.collection-tabs-section .product-grid-slider').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '0rem',
      arrows: false,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 3, // For screens <= 1024px
        },
        768: {
          perPage: 1,
          fixedWidth: '40%',
          gap: '0',
          focus: 'center',
        },
        640: {
          perPage: 1,
          fixedWidth: '70%',
          gap: '0',
          focus: 'center',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });

  document.querySelectorAll('.manual-carousel-wrapper .carousel').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 4,
      perMove: 1,
      gap: '24px',
      arrows: true,
      pagination: false,
      breakpoints: {
        1024: {
          perPage: 3, // For screens <= 1024px
        },
        768: {
          perPage: 1,
          fixedWidth: '40%',
          gap: '15px',
          focus: 'center',
        },
        640: {
          perPage: 1,
          fixedWidth: '70%',
          gap: '15px',
          focus: 'center',
        },
        480: {
          perPage: 1,
          fixedWidth: '40%',
          gap: '10px',
          focus: 'center',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });
  
  document.querySelectorAll('.capsule-products.fall-capsule-slider').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 2,
      perMove: 1,
      gap: '20px',
      arrows: false,
      pagination: false,
      breakpoints: {
        768: {
          gap: '10px',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end  = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });

  const tabs = document.querySelectorAll('.collection-tabs-section .tab-button');
  const contents = document.querySelectorAll('.collection-tabs-section .tab-content');

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => {
      tabs.forEach((btn) => btn.classList.remove('active'));
      contents.forEach((content) => content.classList.remove('active'));
      tab.classList.add('active');
      document.querySelector(`.tab-content[data-tab-index="${index}"]`).classList.add('active');
    });
  });
  
  /* sticky header js */
  window.addEventListener('scroll', function () {
    const header = document.getElementById('header-group');
    const stickyOffset = header.offsetTop;

    if (window.scrollY > stickyOffset) {
      header.classList.add('sticky');
    } else {
      header.classList.remove('sticky');
    }
  });

  /* mobile menu js */

  const submenuToggles = document.querySelectorAll(".menu-drawer__menu .submenu-toggle");

  submenuToggles.forEach((toggle) => {
    const parentLi = toggle.closest("li");
    const submenu = parentLi.querySelector(".menu-level-2");

    if (!submenu) return;

    const backButton = submenu.querySelector(".back-button");

    toggle.addEventListener("click", (e) => {
      e.preventDefault();
      submenu.classList.add("active");
    });

    backButton.addEventListener("click", (e) => {
      e.preventDefault();
      submenu.classList.remove("active");
    });
  });

  const accordionHeaders = document.querySelectorAll(".mm-menu-grid .mm-menu-wrapper h3");
  accordionHeaders.forEach((header) => {
    header.addEventListener("click", () => {
      const item = header.parentElement;
      item.classList.toggle("active");
    });
  });

  document.querySelectorAll('ul.menu-drawer__menu > li a').forEach(item => {
    item.addEventListener('click', function (e) {
      const nextEl = this.nextElementSibling;

      if (nextEl && nextEl.classList.contains('submenu-toggle')) {
        e.preventDefault();
        nextEl.click(); 
      }
    });
  });

/* on  swatch hover change cart product image */
document.querySelectorAll('.custom-product-card .product-swatches a').forEach(swatch => {

    // swatch.addEventListener('mouseenter', function() {
    //     swatch.closest('.product-swatches').querySelectorAll('a.swatch.active').forEach(item => {
    //       item.classList.remove('active');
    //     });
    //     swatch.classList.add('active');
    //     const swatchURL = swatch.dataset.image;
    //     const imgElement = swatch.closest('.custom-product-card').querySelector('img');
    //     if (imgElement) {
    //         imgElement.src = swatchURL;
    //         imgElement.srcset = swatchURL;
    //     }
    // });

    swatch.addEventListener('click', function(e) {
        e.preventDefault();
        swatch.closest('.product-swatches').querySelectorAll('a.swatch.active').forEach(item => {
          item.classList.remove('active');
        });
        swatch.classList.add('active');
        const swatchURL = swatch.dataset.image;
        const imgElement = swatch.closest('.custom-product-card').querySelector('img');
        if (imgElement) {
            imgElement.src = swatchURL;
            imgElement.srcset = swatchURL;
        }
    });
});


/* Add .has-mega-hover when window width >= 990 */
function setupMegaMenuHover() {
  const headerGroup = document.getElementById('header-group');
  const menuItems = document.querySelectorAll('.header-menu__inner li');

  // First, remove any previously attached listeners
  menuItems.forEach(li => {
    const clone = li.cloneNode(true);
    li.replaceWith(clone);
  });

  if (window.innerWidth >= 990) {
    document.querySelectorAll('.header-menu__inner li').forEach(li => {
      if (li.querySelector('.mega-menu-wrapper')) {
        li.addEventListener('mouseenter', () => {
          headerGroup.classList.add('has-mega-hover');
          li.classList.add('active');
        });
        li.addEventListener('mouseleave', () => {
          headerGroup.classList.remove('has-mega-hover');
          li.classList.remove('active');
        });
      }
    });
  } else {
    headerGroup.classList.remove('has-mega-hover'); // Just in case
  }
}
// Run on page load
window.addEventListener('DOMContentLoaded', setupMegaMenuHover);
// Run on resize
window.addEventListener('resize', setupMegaMenuHover);


/* sticky add to cart js */
document.querySelectorAll('.sticky-atc-btns .option-btns-wrap .option-btns').forEach(item => {
    item.addEventListener('click', function() {
        const option_name = item.dataset.option;
        document.querySelector('.sticky-atc-btns .floating-option').style.display = 'block';
        document.querySelectorAll(`.sticky-atc-btns .floating-option .option-values`).forEach(item => { item.classList.remove('active'); })
        document.querySelector(`.sticky-atc-btns .floating-option .option-values[data-option="${option_name}"]`).classList.add('active');
    });
});

document.querySelectorAll('.sticky-atc-btns .floating-option span.cross').forEach(item => {
    item.addEventListener('click', function() {
        const floatingOption = document.querySelector('.sticky-atc-btns .floating-option');
        floatingOption.style.display = 'none';
        
        const activeOption = floatingOption.querySelector('.option-values.active');
        if (activeOption) {
            activeOption.classList.remove('active');
        }
    });
});

document.querySelectorAll('.sticky-atc-btns .floating-option .option-value-wrapper input').forEach(input => {
    input.addEventListener('change', function() {
        const option_value = input.value;
        const option_name = input.getAttribute('name');
        document.querySelectorAll(`.sticky-atc-btns .option-btns[data-option="${option_name}"] button.active`).forEach(btn => {btn.classList.remove('active');});
        const optionButton = document.querySelector(`.option-btns-wrap .option-btns button[data-value="${option_value}"]`);
        const variantInput = document.querySelector(`variant-picker label.variant-option__button-label input[value="${option_value}"]`);

        if (optionButton){ optionButton.classList.add('active');}
        if (variantInput) variantInput.click();
    });
});

/* hide empty accordian */
document.querySelectorAll('.product-information accordion-custom .details-content .ptt-content').forEach(item => {
  if (item.innerHTML.trim() === "") {
    const accordion = item.closest('accordion-custom');
    if (accordion) {
      accordion.style.display = 'none';
    }
  }
});


document.querySelectorAll('.announcement_splide').forEach(function (el) {
  var splide = new Splide(el, {
    type: 'loop',  
    perPage: 1,
    perMove: 1,
    gap: '0rem',
    arrows: true,
    pagination: false,
    autoplay: true, 
    interval: 5000, 
    pauseOnHover: true,
    pauseOnFocus: false
  });

  splide.mount();
});


document.querySelectorAll('.sub_category-wrapper').forEach(function (el) {
    var splide = new Splide(el, {
      type: 'slide',
      perPage: 6,
      perMove: 1,
      gap: '15px',
      arrows: false,
      pagination: false,
      padding: { right: '120px', left: '0' },
      breakpoints: {
        1200: {
          perPage: 5,
          padding: { right: '0', left: '0' },
        },
        1024: {
          perPage: 4,
          padding: { right: '0', left: '0' },
        },
        768: {
          perPage: 4,
          gap: '10px',
          padding: { right: '70px', left: '0' },
        },
        640: {
          perPage: 2,
          gap: '10px',
        },
      },
    });

    var bar = el.querySelector('.my-carousel-progress-bar');

    function updateBar() {
      if (!bar) return;
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      bar.style.width = String(100 * rate) + '%';
    }

    splide.on('mounted updated move', updateBar);
    splide.mount();
  });


  // Product listing page sticky filter bar
    // if (window.innerWidth < 750){
    //   window.addEventListener('scroll', function () {
    //     const coll_body = document.querySelector('.template-collection');
    //     const prod_collFilter = document.querySelector('.frenzy_flex_topbar_contain');
    //     if(prod_collFilter){
    //       if (window.scrollY >= 100) {
    //         coll_body.classList.add('active_body');
    //         prod_collFilter.classList.add('is-sticky');
    //       } else {
    //         coll_body.classList.remove('active_body');
    //         prod_collFilter.classList.remove('is-sticky');
    //       }
    //     }
    //   });
    // }
    function getCollectionStickyHeaderOffset() {
        const headerGroup = document.getElementById('header-group');
        if (!headerGroup) return 96;

        const headerHeight = Math.round(headerGroup.getBoundingClientRect().height);

        if (window.innerWidth <= 767 && headerHeight > 110) {
            return 96;
        }

        return headerHeight || 96;
    }

    function updateCollectionStickyFilter() {
        const coll_body = document.querySelector('.template-collection');
        const prod_collFilter = document.querySelector('.frenzy_flex_topbar_contain');

        if (!prod_collFilter || !coll_body) return;

        if (window.scrollY >= 100) {
            coll_body.classList.add('active_body');
            prod_collFilter.classList.add('is-sticky');
            prod_collFilter.style.setProperty('--collection-sticky-header-offset', `${getCollectionStickyHeaderOffset()}px`);
            prod_collFilter.style.setProperty('top', 'var(--collection-sticky-header-offset, 96px)', 'important');
        } else {
            coll_body.classList.remove('active_body');
            prod_collFilter.classList.remove('is-sticky');
            prod_collFilter.style.removeProperty('--collection-sticky-header-offset');
            prod_collFilter.style.removeProperty('top');
        }
    }

    window.addEventListener('scroll', updateCollectionStickyFilter, { passive: true });
    window.addEventListener('resize', updateCollectionStickyFilter);
    window.addEventListener('orientationchange', updateCollectionStickyFilter);
  // Product listing page sticky filter bar

  // Blog details Product card carousel
    const blog_prodCarousel = document.querySelector('.cust_blog_carousel_main');
    if (blog_prodCarousel) {
      new Splide(blog_prodCarousel, {
        type: 'slide',
        perPage: 4,
        perMove: 1,
        gap: '0px',
        arrows: true,
        pagination: false,
        padding: {
          left: '0px',   // padding at the start
          right: '0px',  // padding at the end
        },
        breakpoints: {
          1024: {
            perPage: 3, // For screens <= 1024px
          },
          990: {
            perPage: 2,
            fixedWidth: '42%',
            gap: '0px',
            focus: 'center',
          },
          640: {
            perPage: 1,
            fixedWidth: '75%',
            gap: '0px',
            focus: 'center',
          },
          480: {
            perPage: 1,
            fixedWidth: '85%',
            gap: '0px',
            focus: 'center',
          },
        },
      }).mount();

    }
  // Blog details Product card carousel

  // Choose 1st color variant in custom product card on loading
  // document.querySelectorAll('.custom-product-card').forEach(function (productItem) {
  //   const swatches = productItem.querySelectorAll(
  //     '.product-card-information .product-swatches .swatch'
  //   );
  //   if (swatches.length > 0) {
  //     swatches[0].click(); // click only the first swatch of this product card
  //   }
  // });
  // Choose 1st color variant in custom product card on loading






/* 22-05-2026 Product media gallery show more/less started */
(function () {
  function setupProductMediaToggle(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-product-media-toggle]').forEach(function (toggle) {
      if (toggle.dataset.productMediaToggleReady === 'true') return;

      toggle.dataset.productMediaToggleReady = 'true';
      toggle.addEventListener('click', function () {
        var gallery = toggle.closest('media-gallery');
        if (!gallery) return;

        var expanded = gallery.classList.toggle('product-media-gallery--expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');

        if (!expanded) {
          var productContent = gallery.closest('.product-information__media') || gallery;
          var header = document.getElementById('header-group');
          var headerOffset = header ? header.offsetHeight : 0;
          var targetTop = productContent.getBoundingClientRect().top + window.pageYOffset - headerOffset - 12;

          window.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth'
          });
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupProductMediaToggle(document);
    });
  } else {
    setupProductMediaToggle(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupProductMediaToggle(event.target);
  });
})();
/* 22-05-2026 Product media gallery show more/less ended */
/* 22-05-2026 PDP discount code copy started */
(function () {
  function copyText(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text);
    }

    var textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.top = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      document.execCommand('copy');
      return Promise.resolve();
    } catch (error) {
      return Promise.reject(error);
    } finally {
      document.body.removeChild(textarea);
    }
  }

  function setupDiscountCopy(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-discount-copy-code]').forEach(function (button) {
      if (button.dataset.discountCopyReady === 'true') return;

      button.dataset.discountCopyReady = 'true';
      button.addEventListener('click', function () {
        var code = button.dataset.discountCopyCode;
        if (!code) return;

        copyText(code).then(function () {
          button.classList.add('is-copied');
          button.setAttribute('aria-label', 'Copied discount code ' + code);

          window.setTimeout(function () {
            button.classList.remove('is-copied');
            button.setAttribute('aria-label', 'Copy discount code ' + code);
          }, 1600);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupDiscountCopy(document);
    });
  } else {
    setupDiscountCopy(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    setupDiscountCopy(event.target);
  });
})();
/* 22-05-2026 PDP discount code copy ended */
/* 25-05-2026 Collection richtext toggle started */
(function () {
  var COLLAPSED_HEIGHT = 200;

  function setupCollectionRichtext(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-collection-richtext]').forEach(function (wrapper) {
      var content = wrapper.querySelector('[data-collection-richtext-content]');
      var toggle = wrapper.querySelector('[data-collection-richtext-toggle]');
      if (!content || !toggle) return;

      var isOverflowing = content.scrollHeight > COLLAPSED_HEIGHT;
      wrapper.classList.toggle('is-collapsible', isOverflowing);

      if (!isOverflowing) {
        wrapper.classList.remove('is-expanded');
        toggle.setAttribute('aria-expanded', 'false');
      }

      if (toggle.dataset.collectionRichtextReady === 'true') return;

      toggle.dataset.collectionRichtextReady = 'true';
      toggle.addEventListener('click', function () {
        var expanded = wrapper.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setupCollectionRichtext(document);
    });
  } else {
    setupCollectionRichtext(document);
  }

  window.addEventListener('resize', function () {
    setupCollectionRichtext(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    setupCollectionRichtext(event.target);
  });
})();
/* 25-05-2026 Collection richtext toggle ended */
/* 25-05-2026 Cart reward auto discount started */
(function () {
  var appliedCodes = {};

  function getCartUpdateUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) {
      return window.Theme.routes.cart_update_url;
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/update.js';
    }

    return '/cart/update.js';
  }

  function refreshCartRewardSections(sectionId, sections) {
    if (!sectionId || !sections || !sections[sectionId]) return;

    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: sections,
        sourceId: 'cart-reward-auto-discount',
        data: {
          source: 'cart-reward-auto-discount',
          sections: sections
        }
      }
    }));
  }


  function applyRewardDiscount(trigger) {
    var code = trigger.getAttribute('data-auto-discount-code');
    var sectionId = trigger.getAttribute('data-section-id');

    if (!code || trigger.getAttribute('data-auto-discount-active') !== 'true' || appliedCodes[code]) return;
    appliedCodes[code] = true;

    fetch(getCartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discount: code,
        sections: sectionId ? [sectionId] : []
      })
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart discount update failed');
        return response.json();
      })
      .then(function (data) {
        if (data && data.sections && data.sections[sectionId]) {
          refreshCartRewardSections(sectionId, data.sections);
        }
      })
      .catch(function () {
        delete appliedCodes[code];
      });
  }

  function setupCartRewardAutoDiscount(root) {
    var scope = root || document;
    var trigger = scope.querySelector('[data-auto-discount-code][data-auto-discount-active="true"]');

    if (trigger) {
      applyRewardDiscount(trigger);
    }
  }

  document.addEventListener('cart:update', function () {
    setupCartRewardAutoDiscount(document);
  });

  document.addEventListener('cart:refresh', function () {
    setupCartRewardAutoDiscount(document);
  });

  window.setupCartRewardAutoDiscount = setupCartRewardAutoDiscount;
})();
/* 25-05-2026 Cart reward auto discount ended */
/* 27-05-2026 Cart recommended quick shop started */
(function () {
  function getCartAddUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) {
      return window.Theme.routes.cart_add_url;
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart/add.js';
    }

    return '/cart/add.js';
  }

  function getCartUrl() {
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) {
      return window.Theme.routes.cart_url + '.js';
    }

    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root + 'cart.js';
    }

    return '/cart.js';
  }

  function getCartSectionIds(fallbackSectionId) {
    var sectionIds = [];

    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      var sectionId = component.getAttribute('data-section-id');
      if (sectionId && sectionIds.indexOf(sectionId) === -1) {
        sectionIds.push(sectionId);
      }
    });

    if (!sectionIds.length && fallbackSectionId) {
      sectionIds.push(fallbackSectionId);
    }

    return sectionIds;
  }

  function dispatchCartRecommendedUpdate(response, variantId, sectionIds) {
    if (!response || !response.sections) return;

    fetch(getCartUrl(), {
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(function (cartResponse) {
        if (!cartResponse.ok) return null;
        return cartResponse.json();
      })
      .catch(function () {
        return null;
      })
      .then(function (cart) {
        var itemCount = cart && typeof cart.item_count === 'number' ? cart.item_count : 1;
        var event = new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: response,
            sourceId: 'cart-recommended-products',
            data: {
              itemCount: itemCount,
              source: 'cart-recommended-products',
              variantId: variantId,
              sections: response.sections
            }
          }
        });

        document.dispatchEvent(event);

        document.dispatchEvent(new CustomEvent('addItemToCartEvent', {
          detail: {
            cart: response,
            quantity: 1,
            sections: response.sections,
            sectionIds: sectionIds
          }
        }));
      });
  }

  function setupCartRecommendedQuickShop(root) {
    var scope = root || document;

    scope.querySelectorAll('[data-cart-recommended-add]:not([data-cart-recommended-bound])').forEach(function (button) {
      button.setAttribute('data-cart-recommended-bound', 'true');

      button.addEventListener('click', function () {
        var variantId = button.getAttribute('data-variant-id');
        var fallbackSectionId = button.getAttribute('data-section-id');
        var sectionIds = getCartSectionIds(fallbackSectionId);

        if (!variantId || button.disabled) return;

        button.disabled = true;
        button.setAttribute('aria-busy', 'true');

        fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1,
            sections: sectionIds.join(','),
            sections_url: window.location.pathname
          })
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart recommended product add failed');
            return response.json();
          })
          .then(function (data) {
            dispatchCartRecommendedUpdate(data, variantId, sectionIds);
          })
          .catch(function (error) {
            console.error(error);
            button.disabled = false;
            button.removeAttribute('aria-busy');
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    setupCartRecommendedQuickShop(document);
  });

  if ('MutationObserver' in window) {
    var cartRecommendedObserver = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (mutations[i].addedNodes.length) {
          setupCartRecommendedQuickShop(document);
          break;
        }
      }
    });

    cartRecommendedObserver.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  window.setupCartRecommendedQuickShop = setupCartRecommendedQuickShop;
})();
/* 27-05-2026 Cart recommended quick shop ended */
/* 04-06-2026 Cart stale interaction lock cleanup started */
// commented this render to fix cart drawer issue
// (function () {
//   var CLEANUP_DELAYS = [250, 900, 1600, 2600];
//   var STALE_DIALOG_MIN_AGE = 1200;
//   var RECENT_CART_CLICK_GRACE = 2200;
//   var lastCartDrawerClickAt = 0;

//   document.addEventListener('click', function (event) {
//     if (event.target?.closest?.('cart-drawer-component > button')) {
//       lastCartDrawerClickAt = Date.now();
//     }
//   }, true);

//   function isElementVisibleInViewport(element) {
//     if (!element || !element.isConnected) return false;

//     var style = window.getComputedStyle(element);
//     if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;

//     var rect = element.getBoundingClientRect();
//     return rect.width > 0 &&
//       rect.height > 0 &&
//       rect.right > 0 &&
//       rect.bottom > 0 &&
//       rect.left < window.innerWidth &&
//       rect.top < window.innerHeight;
//   }

//   function closeStaleDialog(dialog) {
//     if (!dialog || !dialog.open) return;

//     var now = Date.now();
//     var openedAt = parseInt(dialog.dataset.openedAt || '0', 10);
//     var dialogAge = openedAt ? now - openedAt : STALE_DIALOG_MIN_AGE;
//     var userRecentlyClickedCart = now - lastCartDrawerClickAt < RECENT_CART_CLICK_GRACE;
//     var isClosing = dialog.classList.contains('dialog-closing');
//     var isOffscreenStale = !userRecentlyClickedCart &&
//       dialogAge >= STALE_DIALOG_MIN_AGE &&
//       !isElementVisibleInViewport(dialog);

//     if (!isClosing && !isOffscreenStale) return;

//     try {
//       dialog.close();
//     } catch (error) {
//       console.error(error);
//     }

//     dialog.classList.remove('dialog-closing');
//   }

//   function resetBodyLockIfNoDialogOpen() {
//     if (document.querySelector('dialog[open]')) return;

//     var scrollTop = parseInt(document.body.style.top, 10) * -1;

//     document.body.style.width = '';
//     document.body.style.position = '';
//     document.body.style.top = '';
//     document.documentElement.removeAttribute('scroll-lock');

//     if (!Number.isNaN(scrollTop) && scrollTop > 0) {
//       window.scrollTo({ top: scrollTop, behavior: 'instant' });
//     }
//   }

//   function closeStaleSearchOverlay() {
//     var headerGroup = document.getElementById('header-group');
//     var searchQuery = document.getElementById('searchQuery');
//     var searchIsOpen = headerGroup?.classList.contains('search-opened') || !searchQuery?.classList.contains('hidden');

//     if (searchIsOpen) return;

//     headerGroup?.classList.remove('search-opened');
//     document.querySelectorAll('.suggestion__overlay').forEach(function (overlay) {
//       overlay.classList.add('hidden');
//     });
//   }

//   function closeStaleFrenzyOverlays() {
//     document.body.classList.remove('overflow-hidden');

//     document.querySelectorAll('.overlay.active').forEach(function (overlay) {
//       overlay.classList.remove('active');
//     });

//     document.documentElement.classList.remove('is-open-filter');
//     document.body.classList.remove('is-open-filter');
//   }

//   function cleanupStaleInteractionLocks() {
//     document.querySelectorAll('dialog[open]').forEach(closeStaleDialog);
//     resetBodyLockIfNoDialogOpen();
//     closeStaleSearchOverlay();
//     closeStaleFrenzyOverlays();
//   }

//   function scheduleCleanup() {
//     CLEANUP_DELAYS.forEach(function (delay) {
//       window.setTimeout(cleanupStaleInteractionLocks, delay);
//     });
//   }

//   document.addEventListener('cart:update', scheduleCleanup);
//   document.addEventListener('addItemToCartEvent', scheduleCleanup);
//   window.addEventListener('pageshow', scheduleCleanup);

//   window.cleanupStaleInteractionLocks = cleanupStaleInteractionLocks;
// })();
/* 04-06-2026 Cart stale interaction lock cleanup ended */




// Start 11 jun 2026
document.addEventListener('click', function (e) {
  const customBtn = e.target.closest('.cus-minus-cart-delete-btn');

  if (!customBtn) return;

  e.preventDefault();

  const cartRow = customBtn.closest('tr'); // Adjust selector if needed

  if (cartRow) {
    const originalBtn = cartRow.querySelector('.cart-items__remove:not(.cus-minus-cart-delete-btn)');
    if (originalBtn) {
      originalBtn.click();
    }
  }
});
// End 11 jun 2026


// End 18 jun 2026
 const drawerSearchInput = document.querySelector(".cus-header-search-click");
  const headerSearchBtn = document.querySelector(".cus-open-from-drawer");

  if (drawerSearchInput && headerSearchBtn) {
    drawerSearchInput.addEventListener("focus", function () {
      headerSearchBtn.click();
    });
  }

function updateFrenzyPrice() {
  if (window.innerWidth > 767) return;
  document.querySelectorAll('.frenzy_product_item_detail .frenzy_product_price_sale .money').forEach(function(el) {

    if (el.dataset.formatted) return;

    const price = el.textContent.trim();

    if (price.includes('.')) {
      const parts = price.split('.');
      el.innerHTML = `${parts[0]}<sup>.${parts[1]}</sup>`;
      el.dataset.formatted = "true";
    }
  });

 
// Compare Price - Remove decimal part
document.querySelectorAll('.frenzy_product_item_detail .frenzy_product_price_compare .money').forEach(function(el) {

  if (el.dataset.compareFormatted) return;

  el.textContent = el.textContent.trim().replace(/\.\d+$/, '');

  el.dataset.compareFormatted = "true";
});

}

updateFrenzyPrice();
setInterval(updateFrenzyPrice, 1000);

  // End 18 jun 2026